import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './Header';
import Nav from './Navbar';
import Main from './Main';
import './App.css';

const App = () => {
    return (
        <Router>
            <div className='container'>
                <Header />
                <Nav />
                <Main />
            </div>
        </Router>
    );
}

export default App;